// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"747": "765186c4240d489b","757": "9808af1b1e937d7f",}[chunkId] + ".js"
}